import React from 'react';
import { Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  switchTarget: {
    display: 'inline-flex',
    flex: '0 0 auto',
    borderRadius: 999,
  },
  switchRoot: {
    width: '62px !important',
    height: '44px !important',
    padding: '10px !important',
    overflow: 'visible',
  },
  switchBase: {
    padding: '12px !important',
    color: '#fff !important',
    transition: [
      'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
      'color 180ms ease-out',
      'opacity 180ms ease-out',
    ].join(', '),
    '&$switchChecked': {
      color: '#fff !important',
      transform: 'translateX(18px) !important',
    },
    '&$switchChecked + $switchTrack': {
      backgroundColor: 'var(--kea-color-primary) !important',
      opacity: '1 !important',
    },
    '&:not($switchDisabled):hover': {
      backgroundColor: 'rgba(var(--kea-color-primary-rgb), 0.09) !important',
    },
    '&:not($switchDisabled):active $switchThumb': {
      transform: 'scale(0.88)',
      boxShadow: '0 1px 3px rgba(24, 39, 34, 0.24) !important',
    },
    '&:focus-within + $switchTrack': {
      boxShadow: '0 0 0 4px var(--kea-color-focus-ring)',
    },
    '&$switchDisabled': {
      color: '#f8faf9 !important',
      opacity: '0.78 !important',
    },
    '&$switchDisabled + $switchTrack': {
      backgroundColor: '#dfe6e3 !important',
      opacity: '1 !important',
    },
    '&$switchDisabled $switchInput': {
      cursor: 'not-allowed',
    },
  },
  switchThumb: {
    width: '20px !important',
    height: '20px !important',
    boxShadow: [
      '0 1px 2px rgba(24, 39, 34, 0.18)',
      '0 2px 6px rgba(24, 39, 34, 0.12)',
    ].join(', ') + ' !important',
    transition: [
      'transform 120ms ease-out',
      'box-shadow 180ms ease-out',
    ].join(', ') + ' !important',
  },
  switchTrack: {
    borderRadius: '999px !important',
    backgroundColor: '#c4d0cc !important',
    opacity: '1 !important',
    transition: [
      'background-color 220ms ease-out',
      'box-shadow 180ms ease-out',
      'opacity 180ms ease-out',
    ].join(', ') + ' !important',
  },
  switchChecked: {},
  switchDisabled: {},
  switchInput: { cursor: 'pointer' },
}));

export default function DataSettingsToggle({ checked, disabled, onChange, label, describedBy, testId, inputProps = {} }) {
  const classes = useStyles();

  return (
    <span className={classes.switchTarget}>
      <Switch
        checked={checked}
        onChange={onChange}
        color="default"
        classes={{
          root: classes.switchRoot,
          switchBase: classes.switchBase,
          thumb: classes.switchThumb,
          track: classes.switchTrack,
          checked: classes.switchChecked,
          disabled: classes.switchDisabled,
          input: classes.switchInput,
        }}
        disabled={disabled}
        inputProps={{
          ...inputProps,
          'aria-label': label,
          'aria-describedby': describedBy,
          'data-testid': testId,
        }}
      />
    </span>
  );
}
